import ValidationsController from "./validations_controller";

export default class extends ValidationsController {
  static targets = ["email", "emailConfirmation", "submitButton"];
  static values = { currentEmail: String };

  connect() {
    super.connect();
  }

  validate(e) {
    const errorMessages = [];
    const target = e.target;

    if (!target.checkValidity()) {
      errorMessages.push(this.getErrorMessage(target.validity, e.params));
    }

    //現在のメールアドレスと同じかチェック
    if (this.hasEmailTarget && target === this.emailTarget) {
      if (target.value && target.value === this.currentEmailValue) {
        errorMessages.push("現在のメールアドレスとは別のメールアドレスを入力してください。");
      }
    }

    //メールアドレス不一致チェック
    if (this.hasEmailTarget && this.hasEmailConfirmationTarget) {
      if (target === this.emailConfirmationTarget || target === this.emailTarget) {
        const emailValue = this.emailTarget.value;
        const confirmValue = this.emailConfirmationTarget.value;
        if (emailValue && confirmValue && emailValue !== confirmValue) {
          if (target === this.emailConfirmationTarget) {
            errorMessages.push("確認用メールアドレスが一致しません。");
          }
        }
      }
    }

    const formGroup = target.closest(".form-group");
    const templateErrorBlock = formGroup.querySelector(".error-message:not(.error-message--dynamic)");

    formGroup.querySelectorAll(".error-message--dynamic").forEach(el => el.remove());

    if (errorMessages.length > 0) {
      target.classList.add("is-error");
      errorMessages.forEach(message => {
        const newErrorBlock = templateErrorBlock.cloneNode(true);
        newErrorBlock.classList.add("error-message--dynamic");
        newErrorBlock.textContent = message;
        templateErrorBlock.parentNode.insertBefore(newErrorBlock, templateErrorBlock.nextSibling);
      });
    } else {
      target.classList.remove("is-error");
    }

    this.toggleSubmitButton();
  }

  currentEmailValidate() {
    if (this.hasEmailTarget) {
      this.validate({ target: this.emailTarget, params: {} });
    }
  }

  emailMissmatchValidate() {
    if (this.hasEmailConfirmationTarget) {
      this.validate({ target: this.emailConfirmationTarget, params: {} });
    }
  }

  toggleSubmitButton() {
    if (!this.hasSubmitButtonTarget) {
      return;
    }

    const fields = this.element.querySelectorAll(".form-field");

    const hasErrorClass = Array.from(fields).some((el) =>
      el.classList.contains("is-error")
    );

    const hasInvalidField = Array.from(fields).some((field) => {
      if (field.type === "hidden" && field.hasAttribute("required")) {
        return !field.value || field.value.trim() === "";
      }
      return !field.checkValidity();
    });

    const isSameAsCurrentEmail =
      this.hasEmailTarget && this.emailTarget.value === this.currentEmailValue;

    const isEmailMismatch =
      this.hasEmailTarget &&
      this.hasEmailConfirmationTarget &&
      this.emailTarget.value &&
      this.emailConfirmationTarget.value &&
      this.emailTarget.value !== this.emailConfirmationTarget.value;

    this.submitButtonTarget.disabled =
      hasErrorClass || hasInvalidField || isSameAsCurrentEmail || isEmailMismatch;
  }
}